var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Box, Typography } from "@mui/material";
export function EmptyDashboardState(_a) {
    var _b = _a.message, message = _b === void 0 ? "Dados não disponíveis para esta consulta." : _b, _c = _a.minHeight, minHeight = _c === void 0 ? 200 : _c;
    return (_jsx(Box, __assign({ sx: {
            background: "#fff",
            borderRadius: "14px",
            border: "1px solid #ECEEF4",
            minHeight: minHeight,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            p: 2.5,
            width: "100%",
        } }, { children: _jsx(Typography, __assign({ sx: {
                fontFamily: "Montserrat, sans-serif",
                fontSize: "0.82rem",
                color: "#4B5563",
                textAlign: "center",
            } }, { children: message })) })));
}
